var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bxs-check-circle",
    d: "M12.5,3A9.5,9.5,0,1,0,22,12.5,9.511,9.511,0,0,0,12.5,3ZM10.6,16.693l-3.527-3.52,1.341-1.345,2.184,2.18,5.029-5.029,1.343,1.343L10.6,16.692Z",
    transform: "translate(-3 -3)",
    fill: "#7bc807"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/accepted.1072eed0.svg";
export { ForwardRef as ReactComponent };